import { useNavigation } from '@react-navigation/native';
import { BaseText, theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native-gesture-handler';
import { featureCountryCode } from 'states/persistInStorage';
import { StyledWrapper } from 'styles/ContainerStyles';
import { CountryCode } from 'types/generatedSchemaTypes';
import { AccountNavProps } from 'types/navigation';
import { useUiStore } from 'stores/uiStore';

const CountryOption = ({ countryCode }: { countryCode: CountryCode }) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<AccountNavProps>();

  const handlePress = () => {
    featureCountryCode(countryCode);
    useUiStore.getState().setSheetModal('');
    navigate('contactUs');
  };

  return (
    <MenuItem
      menuLabel={t(`account.appLocations.${countryCode}`)}
      withArrow
      iconName={`flag-${countryCode}`}
      onPress={handlePress}
    />
  );
};

const ContactUsSelectCountry = () => {
  const { t } = useTranslation();

  return (
    <ScrollView>
      <StyledWrapper maxWidth={350} center mb={30}>
        <BaseText center color={theme.colors.gray300}>
          {t('account.supportSelectCountry')}
        </BaseText>
      </StyledWrapper>
      <StyledWrapper mb={50}>
        <CountryOption countryCode="FI" />
        <CountryOption countryCode="SE" />
      </StyledWrapper>
    </ScrollView>
  );
};

export default ContactUsSelectCountry;
